import axios from "axios";
import { getToken } from "../App";
import { toast } from "react-toastify";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "Accept-Type": "application/json",
  },
});


api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let isRedirecting = false;

export function redirectToLogin() {

  if (!isRedirecting) {
    isRedirecting = true;
    toast.error('Session has timed out!', { autoClose: 3000 });
    setTimeout(() => {
      localStorage.clear();
      window.location.href = "/login";
    }, 3000);
  }
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const token = getToken()
    if (error.response?.data?.detail==="Invalid username or password") {
         console.log("Invalid username or password")
    }
    else if (token && error.response?.status === 401  && !isRedirecting){
    redirectToLogin();
    }
    return Promise.reject(error);
  }
);

export default api;
